/* eslint-disable no-underscore-dangle */
import QueryWhereRule from '~/scripts/services/model/query-where-rule';
import QueryWhereNode from '~/scripts/services/model/query-where-node';
import QueryRule from '~/scripts/services/model/query-rule';
import {
	operators,
	operatorsByType,
	types,
} from '../query-editor/query-editor.controller';
import {
	defaultDateRange,
	fields,
} from '../query-rule/query-rule.controller';

export default class QueryRuleOperatorController {
	/* @ngInject */
	constructor() {
		/** @type {?import('../query-builder-children/query-builder-children.controller').default} */
		this.children = null;

		this.group = undefined;
		this.node = undefined;

		/** @type {any[]} */
		this.operators = [];

		/** @type {any} */
		this.rule = undefined;
		this.types = types;
	}

	changeOperator() {
		// if (this.rule.operator === 'class') {
		// 	this.rule._type = 'child';
		// 	this.rule.rules = [];
		// 	// const newRule = new QueryWhereNode();
		// 	// this.rule.rules = [newRule];
		// }
		// else {
		// 	this.rule._type = 'leaf';
		// }
		// this.rule.value = operators[this.rule.operator]?.nb_inputs > 1 ? [] : undefined;
		if (this.rule instanceof QueryWhereRule) {
			if (this.rule.operator === 'equal_kid' || this.rule.operator === 'not_equal_kid') {
				this.rule.field = 'kid';
			}
			else if (this.rule.field === 'kid') {
				const operators = this.operators.find(
					(/** @type {any} */ op) => this.rule instanceof QueryWhereRule && op.id === this.rule.operator,
				);
				if (operators?.fields && operators.fields.length > 0) {
					this.rule.field = operators.fields[0];
				}

				// Automatically sets "K_NODE;UNIVERSEL" for repre field
				if (this.rule.field === 'repre') {
					if (!this.rule.lang_kid) {
						this.rule.lang_kid = 'K_NODE;UNIVERSEL';
					}
				}
				else {
					this.rule.lang_kid = undefined;
				}
			}
		}

		if (operators[this.rule.operator]?.nb_inputs > 1) {
			this.rule.value = [].constructor(operators[this.rule.operator].nb_inputs);
			if (this.rule.isDateRange()) {
				this.rule.value.fill(defaultDateRange);
			}
		}
		else {
			this.rule.value = undefined;
			if (this.rule.isDateRange()) {
				this.rule.value = defaultDateRange;
			}
		}
	}

	$doCheck() {
		if (this.rule instanceof QueryRule) {
			if (this.rule.type) {
				this.operators = operatorsByType[types[this.rule.type]];
			}
			this.node = this.children?.group?.node;
		}
		else if (this.rule instanceof QueryWhereRule) {
			this.node = this.rule.getNode();
		}
		if (this.node instanceof QueryWhereNode) {
			const field = this.rule.field && fields.find(
				f => f.id === (this.rule.field === 'repre' || this.rule.field === 'kid' ? 'name' : this.rule.field),
			);
			this.operators = operatorsByType[field?.type ?? types[this.node.type]].filter(
				(/** @type {any} */ o) => {
					if (field.id === 'name') {
						return o.fields.includes('kid') || o.fields.includes('repre');
					}
					return o.fields.includes(this.rule.field);
				},
			);
		}
		else {
			console.warn('Unable to load operators because node was not found', this);
		}

		// Automatically sets the first operator
		if (!this.rule.operator && this.operators?.length > 0) {
			this.rule.operator = this.operators[0].id;
		}
	}
}
